import React from 'react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import * as translationService from '../services/translationService'
import * as routeService from '../services/routeService'
import { getCurrentStepType } from '../services/stepService'

import FormStepper from 'components/FormStepper'
import { Button, ButtonGroup, TextContainer, PropertyBar } from './../components'
import ContractScene from './scenes/ContractScene'
import { scroller } from 'react-scroll'

const mapStateToProps = ({ AuthReducer, FlowReducer, AppReducer }) => {
  const { user = {} } = AuthReducer
  const { step, property } = FlowReducer
  const { isUploading } = AppReducer
  return {
    user,
    step,
    property,
    isUploading,
  }
}

// const types = [
//   {
//     id: 'INTAKE_INCOME_SALARY',
//     title: translationService.incomeSalary(),
//     icon: <Icon source="salary" />,
//     min: 0,
//   },
//   {
//     id: 'INTAKE_INCOME_PENSION',
//     title: translationService.incomePension(),
//     icon: <Icon source="pension" />,
//     min: 0,
//   },
//   {
//     id: 'INTAKE_INCOME_DOLE',
//     title: translationService.incomeDole(),
//     icon: <Icon source="dole" />,
//     min: 0,
//   },
//   {
//     id: 'INTAKE_INCOME_ALIMONY',
//     title: translationService.incomeAlimony(),
//     icon: <Icon source="alimony" />,
//     min: 0,
//   },
//   {
//     id: 'INTAKE_INCOME_CHILDBENEFIT',
//     title: translationService.incomeChildBenefit(),
//     icon: <Icon source="childBenefit" />,
//     min: 0,
//   },
//   {
//     id: 'INTAKE_INCOME_INTERESTS',
//     title: translationService.incomeInterests(),
//     icon: <Icon source="interests" />,
//     min: 0,
//   },
//   {
//     id: 'INTAKE_INCOME_SAVINGS',
//     title: translationService.incomeSavings(),
//     icon: <Icon source="savings" />,
//     min: 0,
//   },
//   {
//     id: 'INTAKE_INCOME_OTHER',
//     title: translationService.incomeOther(),
//     icon: <Icon source="income" />,
//     min: 0,
//   },
// ]

class ContractView extends React.Component {
  static propTypes = {
    user: PropTypes.any,
    step: PropTypes.any,
    property: PropTypes.object,
    isUploading: PropTypes.bool,
  }

  contractRef = {}

  componentDidMount = () => {
    scroller.scrollTo('mainContent', {
      smooth: true,
    })
  }

  componentDidMount = () => {
    scroller.scrollTo('mainContent', {
      smooth: true,
    })
  }

  goToPreviousFlow = () => {
    this.contractRef
      .onSubmit(false)
      .then(() => {
        routeService.goToNextFlowPage(this.props.step, -1)
      })
      .catch(() => {})
  }

  goToNextFlow = () => {
    this.contractRef
      .onSubmit()
      .then(() => {
        routeService.goToNextFlowPage(this.props.step)
      })
      .catch(() => {})
  }

  render() {
    const { property, step } = this.props
    const stepType = getCurrentStepType(step)

    return (
      <div>
        {property && <PropertyBar property={property} />}
        <FormStepper steps={routeService.getStepperRoutes(this.props.step, property.zip)} />
        <TextContainer>
          <ContractScene onRef={ref => (this.contractRef = ref)} />
          <div>
            <ButtonGroup>
              {stepType !== 'CANDIDACY_REQUEST_STEPS' && (
                <Button onClick={this.goToPreviousFlow}>{translationService.buttonPrevious()}</Button>
              )}
              <Button onClick={() => this.goToNextFlow()} primary loading={this.props.isUploading}>
                {translationService.buttonNext()}
              </Button>
            </ButtonGroup>
          </div>
        </TextContainer>
      </div>
    )
  }
}

export default compose(connect(mapStateToProps))(ContractView)



// WEBPACK FOOTER //
// ./src/views/ContractView.js